module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-sabrina.eaeaa92b.jpeg";